export const BuildInfo = {timestamp:1775079865000}
